<template>
  <div v-if="path" class="swap-share">
    <FomoButton variant="quiet" icon="fas fa-link" @click="copyLink">Copiar enlace</FomoButton>
    <small v-if="copied" role="status">Enlace copiado</small>
    <div v-if="fallback" class="swap-share__fallback">
      <label>Enlace de tu publicación<input ref="link" type="url" :value="url" readonly @focus="$event.target.select()" /></label>
      <small role="status">Selecciona y copia este enlace para compartir tus entradas.</small>
    </div>
  </div>
</template>
<script>
import FomoButton from '../ui/FomoButton.vue'
import { swapListingSharePath } from '../../common/swapShare'
export default {
  components: { FomoButton },
  props: { listing: { type: Object, required: true } },
  data: () => ({ copied: false, fallback: false }),
  computed: {
    path() { return swapListingSharePath(this.listing) },
    url() { return this.path ? new URL(this.path, window.location.origin).href : '' },
  },
  methods: {
    async copyLink() {
      this.copied = false
      try {
        await navigator.clipboard.writeText(this.url)
        this.copied = true; this.fallback = false
      } catch (_) {
        this.fallback = true
        await this.$nextTick()
        this.$refs.link?.focus(); this.$refs.link?.select()
      }
    },
  },
}
</script>
<style scoped>
.swap-share{display:grid;gap:8px;min-width:0;max-width:100%;justify-items:start}
.swap-share small{font:400 12px/1.5 var(--fomo-font-body);color:var(--fomo-dashboard-copy)}
.swap-share__fallback{display:grid;gap:8px;width:100%;min-width:0}
.swap-share__fallback label{display:grid;gap:8px;font:400 12px var(--fomo-font-body)}
.swap-share__fallback input{width:100%;min-width:0;box-sizing:border-box;font-size:16px}
</style>
